// extracted by mini-css-extract-plugin
module.exports = {"controlBar":"add-edit-sucession-planning_controlBar__6r8uL","mainTitle":"add-edit-sucession-planning_mainTitle__2yRiU","subText":"add-edit-sucession-planning_subText__v56qj"};